<div class="card primary">
    <div class="card-header text-white bg-primary">
        <div class="row">
            <a class="col text-white indicator caret-toggle" href="Javascript://" (click)="toggleCommentDisplay()" [attr.aria-expanded]="!isCommentCollapsed" aria-controls="rubric-comments">
                <i class="fa-solid fa-caret-up" *ngIf="isCommentCollapsed"></i>
                <i class="fa-solid fa-caret-down" *ngIf="!isCommentCollapsed"></i>
            </a>
            <div class="col-8">
                <a class="text-white pe-4 comment-title" href="Javascript://" (click)="toggleCommentDisplay()" [attr.aria-expanded]="!isCommentCollapsed" aria-controls="rubric-comments">
                    <b>{{title}}</b>
                    <app-observation-comments-indicator class="ms-2" [domainFilterId]="domainFilterId"></app-observation-comments-indicator>
                </a>
            </div>
            <div class="col-4">
                <form *ngIf="!hideFilter" class="d-flex flex-row align-items-center flex-wrap justify-content-end">
                    <edl-floating-label-container label="Domain" for="domainFilter" class="w-auto">
                        <select #domainFilter id="domainFilter" class="form-select" (change)="changeDomainFilter(domainFilter.value)">
                            <option [defaultSelected]=true value="0">All Domains</option>
                            <option *ngFor="let opt of domainFilterOptions" [value]="opt.Value">{{ opt.Label }}</option>
                        </select>
                    </edl-floating-label-container>
                </form>
            </div>
        </div>
        <div *ngIf="subtitle" class="row">
            <span class="col indicator"></span>
            <div class="col">
                <div>
                    <span class="indicator"></span>
                </div>
                <span>{{subtitle}}</span>
                <edl-tooltip *ngIf="!!help" [icon]="EdlTooltipIcon.INFO" [help]="help"></edl-tooltip>
            </div>
        </div>
    </div>
    <div *ngIf="!isCommentCollapsed" class="card-body">
        <div *ngIf="!isInitialized" class="text-center">
            <i class="fas fa-spinner fa-spin" role="status" aria-label="Loading"></i>
        </div>
        <ul *ngIf="isInitialized">
            <li *ngFor="let comment of filteredComments; let i = index; trackBy: trackByFn">
                <app-observation-comment-cell
                    [(comment)]="filteredComments[i]"
                    [observationType]="observationType"
                    [observationSummary]="observationSummary"
                    [hideFilter]="hideFilter"
                    [evalUser]="evalUser"
                    [(isEditMode)]="isEditMode[comment.commentID]"
                    [isReadOnly]="isReadOnly"
                    [attachmentLabel]="attachmentLabel"
                    >
                </app-observation-comment-cell>
            </li>
            <li *ngIf="!isReadOnly">
                <app-observation-comment-cell
                    [(comment)]="newComment"
                    [observationType]="observationType"
                    [observationSummary]="observationSummary"
                    [hideFilter]="hideFilter"
                    [evalUser]="evalUser"
                    [defaultLookupValue]="defaultDomainFilterId"
                    [attachmentLabel]="attachmentLabel"
                    [isEditMode]="isEditMode[NEW_COMMENT_ID]"
                    (isEditModeChange)="isEditModeChanged_NewComment($event)"
                >
                </app-observation-comment-cell>
            </li>
        </ul>
    </div>
</div>
